import styled from "styled-components";

export const DeprecationContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('/assets/pics/background.svg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  font-family: ${({ theme }) => theme.tokens?.fonts?.family?.main || 'Latam_Sans'}, sans-serif;
  padding: 24px;
  transition: background 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: ${({ theme }) => theme.tokens?.color?.surface?.primary || '#ffffff'}dd;
    z-index: 0;
  }
`;

export const ContentBox = styled.div`
  max-width: 700px;
  width: 100%;
  text-align: center;
  position: relative;
  z-index: 1;
  background: ${({ theme }) => theme.tokens?.color?.surface?.primary || '#ffffff'}ee;
  padding: 64px 48px;
  border-radius: 24px;
  border: 1px solid ${({ theme }) => theme.tokens?.color?.border?.primary || '#e5e5e5'};
  backdrop-filter: blur(10px);
  animation: fadeIn 0.6s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @media (max-width: 768px) {
    padding: 48px 32px;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin-bottom: 48px;
`;

export const Logo = styled.img`
  height: 60px;
  width: auto;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 48px;
  }
`;

export const Title = styled.h1`
  font-size: 2.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.tokens?.color?.text?.primary || '#303030'};
  margin: 0 0 24px 0;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const Subtitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 400;
  color: ${({ theme }) => theme.tokens?.color?.text?.secondary || '#595959'};
  margin: 0 0 40px 0;
`;

export const Divider = styled.div`
  width: 80px;
  height: 3px;
  background: ${({ theme }) => `linear-gradient(90deg,
    ${theme.tokens?.color?.interaction?.mediumDefault || '#e82333'},
    ${theme.tokens?.color?.interaction?.softDefault || '#2c31c9'}
  )`};
  margin: 0 auto 40px;
  border-radius: 2px;
`;

export const Message = styled.p`
  font-size: 1.125rem;
  color: ${({ theme }) => theme.tokens?.color?.text?.secondary || '#595959'};
  margin: 0 0 24px 0;
  line-height: 1.6;
`;

export const LinkBox = styled.div`
  background: ${({ theme }) => theme.tokens?.color?.surface?.secondary || '#f8f9fa'};
  padding: 24px;
  border-radius: 12px;
  margin: 32px 0;
  border: 2px solid ${({ theme }) => theme.tokens?.color?.border?.primary || '#e5e5e5'};
  transition: all 0.3s ease;

  &:hover {
    border-color: ${({ theme }) => theme.tokens?.color?.interaction?.softDefault || '#2c31c9'};
    box-shadow: 0 4px 16px ${({ theme }) => theme.tokens?.color?.interaction?.softDefault || '#2c31c9'}20;
  }
`;

export const Link = styled.a`
  display: inline-block;
  font-size: 1.5rem;
  font-weight: 600;
  color: ${({ theme }) => theme.tokens?.color?.interaction?.softDefault || '#2c31c9'};
  text-decoration: none;
  transition: color 0.2s ease;

  &:hover {
    color: ${({ theme }) => theme.tokens?.color?.interaction?.softActive || '#1a1d7a'};
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.tokens?.color?.border?.focusStandard || '#0a0e80'};
    outline-offset: 4px;
  }
`;

export const Description = styled.p`
  font-size: 1rem;
  color: ${({ theme }) => theme.tokens?.color?.text?.secondary || '#595959'};
  margin: 32px auto;
  max-width: 520px;
  line-height: 1.7;
`;

export const WarningBox = styled.div`
  background: ${({ theme }) => theme.tokens?.color?.surface?.warningSoft || '#fff3cd'};
  border-left: 4px solid ${({ theme }) => theme.tokens?.color?.interaction?.warningStrong || '#ffc107'};
  padding: 16px 24px;
  border-radius: 8px;
  margin: 32px 0;
`;

export const DeprecationWarning = styled.p`
  font-size: 0.9rem;
  font-weight: 500;
  color: ${({ theme }) => theme.tokens?.color?.text?.primary || '#303030'};
  margin: 0;
`;

export const CountdownText = styled.p`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.tokens?.color?.text?.tertiary || '#8c8c8c'};
  margin: 24px 0 0;

  span {
    display: inline-block;
    min-width: 20px;
    font-family: 'Courier New', monospace;
    font-weight: 700;
    font-size: 1rem;
    color: ${({ theme }) => theme.tokens?.color?.interaction?.mediumDefault || '#e82333'};
  }
`;
